import { getStorageData, removeStorageData, setStorageData } from "@/_utils";

export const usePricingStorage = () => {
  const storageKey = "pricing_plan_selected";
  const setPricingPlanSelected = (pricingPlanId: string, billing: string) => {
    setStorageData(storageKey, {
      pricingPlanId,
      billing,
    });
  };
  const getPricingPlanSelected = () => {
    return getStorageData<{ pricingPlanId: string; billing: string }>(
      storageKey,
    );
  };
  const removePricingPlanSelected = () => {
    removeStorageData(storageKey);
  };
  return {
    setPricingPlanSelected,
    getPricingPlanSelected,
    removePricingPlanSelected,
  };
};
